import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  LabelList,
} from "recharts";
import Card from "../../../Components/Card";
import { decimalFormatter } from "../../../Utils/Formatter";

const HorizontalStackedBarChart = ({ data, showOsSystems }) => {
  // Stelle sicher, dass deine Daten sortiert und auf die Top 10 beschränkt sind
  const sortedData = data
    .map((acft) => {
      return {
        ...acft,
        android: acft.android ? parseInt(acft.android) : 0,
        ios: acft.ios ? parseInt(acft.ios) : 0,
        linux: acft.linux ? parseInt(acft.linux) : 0,
        macos: acft.macos ? parseInt(acft.macos) : 0,
        win64: acft.win64 ? parseInt(acft.win64) : 0,
        sum: acft.total ? parseInt(acft.total) : 0,
      };
    })
    .sort((a, b) => b.sum - a.sum);
  return (
    <div style={{ width: "100%" }}>
      {/* Scrollbarer Bereich für Balken */}
      <div style={{ width: "100%", height: "800px", overflowY: "auto" }}>
        <ResponsiveContainer width="100%" height={2000}>
          <BarChart
            data={sortedData}
            layout="vertical"
            margin={{ top: 0, right: 30, left: 20, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" />

            <YAxis
              dataKey="acft"
              type="category"
              tickLine={false}
              tickCount={1} // kannst du ggf. entfernen, ist nicht nötig
              width={100}
              interval={0} // <-- Wichtig: verhindert das automatische Überspringen von Labels
            />

            <Tooltip content={<CustomTooltip />} />
            <XAxis type="number" hide />
            <Bar dataKey="ios" stackId="a" fill="#A87BCC" label="test" />
            <Bar dataKey="android" stackId="a" fill="#9FCC7B" />
            <Bar dataKey="win64" stackId="a" fill="#064CC4" />
            <Bar dataKey="macos" stackId="a" fill="#3b82f6" />
            <Bar dataKey="switch" stackId="a" fill="#F74251" />
            <Bar dataKey="linux" stackId="a" fill="#06b6d4" />
            {/* Füge LabelList hinzu, um die Summe anzuzeigen */}
            <LabelList
              dataKey="sum"
              position="right"
              formatter={(value) => decimalFormatter.format(value)}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-4">
        <ResponsiveContainer width="100%" height={showOsSystems ? 60 : 30}>
          <BarChart
            data={sortedData}
            layout="vertical"
            margin={{ top: 0, right: 45, left: 80, bottom: 0 }}
          >
            <XAxis type="number" dataKey={"sum"} />
            {showOsSystems && (
              <Legend
                payload={[
                  {
                    value: "ios",
                    type: "rect",
                    color: "#A87BCC",
                  },
                  {
                    value: "android",
                    type: "rect",
                    color: "#9FCC7B",
                  },
                  {
                    value: "win64",
                    type: "rect",
                    color: "#064CC4",
                  },
                  {
                    value: "macos",
                    type: "rect",
                    color: "#3b82f6",
                  },
                  {
                    value: "linux",
                    type: "rect",
                    color: "#06b6d4",
                  },
                  {
                    value: "switch",
                    type: "rect",
                    color: "#F74251",
                  },
                ]}
              />
            )}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
const CustomTooltip = ({ active, payload, label, showOsSystems }) => {
  if (active && payload && payload.length) {
    return (
      <Card>
        <p className="text-sm mb-2">{label}</p>
        {payload?.map((item, index) => (
          <div
            key={item.name}
            className="grid grid-cols-12 text-sm"
            style={{ color: item.color ?? item.fill }}
          >
            <p className="col-span-6 border-t border-gray-200">{item.name}</p>

            <p className="col-span-4 border-t border-gray-200">
              {decimalFormatter.format(item.value)}{" "}
            </p>
            <p className=" col-span-2 border-t border-gray-200 ">
              {item?.payload?.sum > 0
                ? ((item.value / item?.payload?.sum) * 100).toFixed(0) + "%"
                : ""}
            </p>
          </div>
        ))}
        <div className="grid grid-cols-12 text-sm">
          <p className="col-span-6 border-t border-gray-400 font-bold ">
            {"total"}
          </p>
          <p className="col-span-4 border-t border-gray-400 font-bold">
            {decimalFormatter.format(
              payload.reduce((acc, curr) => acc + curr.value, 0)
            )}
          </p>
          <p className=" col-span-2 border-t border-gray-400 "></p>
        </div>
      </Card>
    );
  }

  return null;
};

export default HorizontalStackedBarChart;
